module.exports = "/_next/static/images/oilAndNaturalGasConstructionServices-06b20ba3ef6daaeeb44b244a93505a2e.webp";